export default __webpack_public_path__ + "/dist/images/check_img.0eb86b73ea87c9741c66af598e6de180.svg";